module.exports = __webpack_public_path__ + "static/media/18.2b68af81.jpg";